import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {UnsubscribeOnDestroyAdapter} from '@shared';
import {DefaultResponse} from "@core/models/Http/DefaultResponse";
import {environment} from "@enviroment/environment";
import {PatientHealthEvent} from "@core/models/PatientHealthEvent";
import {HttpMesageHandlerService} from "@core/service/http-mesage-handler";

@Injectable({
  providedIn: 'root',
})

export class PatientByIdHealthEventService extends UnsubscribeOnDestroyAdapter {
  isTblLoading = true;
  dataChange: BehaviorSubject<PatientHealthEvent[]> = new BehaviorSubject<PatientHealthEvent[]>([]);
  dialogData!: PatientHealthEvent;

  constructor(
    private httpClient: HttpClient,
    private httpMsgHandler: HttpMesageHandlerService
  ) {
    super();
  }

  get data(): PatientHealthEvent[] {
    return this.dataChange.value;
  }

  getDialogData() {
    return this.dialogData;
  }

  /** CRUD METHODS */
  getAllPatientByIdHealthEvents(idPatient: string): void {
    this.subs.sink = this.httpClient.post<DefaultResponse<PatientHealthEvent[]>>(
      `${environment.backend_url}Consulta/eventosSalud`,
      JSON.stringify(idPatient),
      {
        headers: new HttpHeaders({'Content-Type': 'application/json'})
      }).subscribe({
      next: (data) => {
        let filteredData = data.data.map(event => ({
          ...event,
          fecha: event.fecha.split('T')[0],
        }));

        this.isTblLoading = false;
        this.dataChange.next(filteredData);
      },
      error: (error: HttpErrorResponse) => {
        this.isTblLoading = false;
        this.httpMsgHandler.handleMsg(error);
      },
    });
  }
}
